import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { DataViewOptions } from '@adornis/data-view/client/data-view-options.js';
import { permissionGuard } from '@adornis/user-forms/permission-guard.js';
import { ANY_CONTEXT } from '@adornis/users/db/a-roles.js';
import { CampusLernheft } from '@chancenwerk/campus-learning-content/entities/CampusLernheft.js';
import '@chancenwerk/client/components/chancen-component-card-title.js';
import { ChromiumDialog } from '@chancenwerk/client/design/components/cr-dialog.js';
import { ChancenPermission } from '@chancenwerk/db/permissions.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../components/campus-component-teacher-dashboard-lesson-list.js';
import './campus-page-no-permission.js';

@customElement('campus-page-teacher-dashboard-hefte')
export class CampusPageTeacherDashboardHefte extends ChemistryLitElement {
  private readonly size = new WindowSizeController(this);

  override styles = () => [
    {
      ':host': {
        // height: '100%',
        width: '100%',
      },
    },
  ];

  override render() {
    return permissionGuard(ChancenPermission.campus.EDIT_LERNHEFTE, () => this._content(), {
      forbiddenTemplate: html`<campus-page-no-permission></campus-page-no-permission>`,
      context: ANY_CONTEXT,
    });
  }

  private _content() {
    return html`
      <cr-flex padding="${this.size.mobile ? 'md' : 'lg'}" space="lg">
        <cr-flex space="lg">
          <cr-h2> Lernhefte </cr-h2>
        </cr-flex>

        <cr-card space="md" padding="md">
          <cr-data-view
            .options=${{
              class: CampusLernheft,
              onlyShowLastTranslation: true,
              customColumns: [
                {
                  fieldName: 'title',
                  columnName: 'Titel',
                },
                {
                  customID: 'actions',
                  columnName: 'Aktionen',
                  columnWidth: 'max-content',
                  getFieldMapping: (e: CampusLernheft) => {
                    return html`<cr-flex horizontal space="md">
                      <cr-button
                        mode="icon"
                        icon="delete"
                        tone="error"
                        @click=${async () => {
                          if (await ChromiumDialog.confirm('Lernheft wirklich löschen?')) {
                            await e.remove();
                          }
                        }}
                      >
                      </cr-button>
                      <cr-button
                        mode="icon"
                        icon="edit"
                        @click=${async () => {
                          const res = await ChromiumDialog.prompt('Titel bearbeiten', { placeholder: 'Titel' });
                          if (res) {
                            e.title = res;
                            await e.save();
                          }
                        }}
                      >
                      </cr-button>
                    </cr-flex>`;
                  },
                },
              ],
            } as DataViewOptions<typeof CampusLernheft>}
          >
          </cr-data-view>
          <cr-button
            ${css({ maxWidth: '280px' })}
            @click=${async () => {
              const res = await ChromiumDialog.prompt('Neues Lernheft erstellen', { placeholder: 'Titel' });
              if (res) {
                await new CampusLernheft({
                  title: res,
                }).create();
              }
            }}
          >
            Neues Lernheft erstellen
          </cr-button>
        </cr-card>

        <cr-flex w100 ${css({ height: '100px' })}></cr-flex>
      </cr-flex>
    `;
  }
}
